import http from "../plugins/axios";

const loadRoles = async () => {
    const response = await http.get('/api/company/v3/role');
    return response.data;
};

const loadAppRoles = async () => {
    const response = await http.get('/api/company/v3/role/app');
    return response.data;
};

const loadRolesApiCall = async (
    abortController = null,
) => {
    const { data } = await http.get('/api/company/v3/role', { signal: abortController?.signal })
    return data
}

const loadPermissionsApiCall = async (
    abortController = null,
) => {
    const { data } = await http.get('/api/company/v3/permissions', { signal: abortController?.signal })
    return data
}

const createRoleApiCall = async (
    params,
    abortController = null,
) => {
    const { data } = await http.post('/api/company/v3/role',
        { ...params },
        { signal: abortController?.signal })
    return data.data
}

const updateRoleApiCall = async (
    params,
    abortController = null,
) => {
    const { data } = await http.patch(`/api/company/v3/role/${params.id}`,
        { ...params.data },
        { signal: abortController?.signal })
    return data.data
}

const deleteRoleApiCall = async (
    params,
    abortController = null,
) => {
    const { data } = await http.delete(`/api/company/v3/role/${params.id}`,
        { signal: abortController?.signal })

    return data
}


export { loadRoles, loadAppRoles, loadRolesApiCall, loadPermissionsApiCall, createRoleApiCall, updateRoleApiCall, deleteRoleApiCall };
